import { TECH_STACK_ITEMS, TECH_STACK_ICON_COLOR, TECH_STACK_ICON_COLOR_ON_DARK, resolveTechStackIconSrc } from "@/data/techStackItems";
import "./TechStackStrip.css";

function TechStackIcon({ item, iconColor }) {
  return (
    <img
      src={resolveTechStackIconSrc(item, iconColor)}
      alt=""
      className="ds-about-tech-strip__icon"
      width={22}
      height={22}
      loading="lazy"
      decoding="async"
      onError={(e) => {
        e.currentTarget.style.visibility = "hidden";
      }}
    />
  );
}

function MarqueeRow({ items, rowKey, iconColor, ariaHidden = false }) {
  return (
    <div className="ds-about-tech-strip__track" aria-hidden={ariaHidden || undefined}>
      {items.map((item, index) => (
        <span key={`${rowKey}-${item.slug}-${index}`} className="ds-about-tech-strip__item">
          <TechStackIcon item={item} iconColor={iconColor} />
          <span className="ds-about-tech-strip__name">{item.name}</span>
        </span>
      ))}
    </div>
  );
}

export default function TechStackStrip({ variant = "light", className = "" }) {
  const loop = [...TECH_STACK_ITEMS, ...TECH_STACK_ITEMS];
  const variantClass =
    variant === "light" ? "ds-about-tech-strip--light" : "ds-about-tech-strip--dark";
  const iconColor =
    variant === "dark" ? TECH_STACK_ICON_COLOR_ON_DARK : TECH_STACK_ICON_COLOR;

  return (    <div
      className={`ds-about-tech-strip ${variantClass}${className ? ` ${className}` : ""}`}
      aria-label="기술 스택"
    >
      <div className="ds-about-tech-strip__label">Tech Stack</div>
      <div className="ds-about-tech-strip__viewport">
        <div className="ds-about-tech-strip__marquee">
          <MarqueeRow items={loop} rowKey="a" iconColor={iconColor} />
          <MarqueeRow items={loop} rowKey="b" iconColor={iconColor} ariaHidden />        </div>
      </div>
      <ul className="ds-about-tech-strip__static" aria-hidden="true">
        {TECH_STACK_ITEMS.map((item) => (
          <li key={item.slug} className="ds-about-tech-strip__item">
            <TechStackIcon item={item} iconColor={iconColor} />
            <span className="ds-about-tech-strip__name">{item.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
